import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { PageRequest } from '../../lib/api/paging';
import { listContent, listDownloads, trackDownload, type ContentParams } from './api';

export const contentKeys = {
  all: ['content'] as const,
  list: (p: ContentParams) => [...contentKeys.all, 'list', p] as const,
  downloads: (id: string, p: PageRequest) => [...contentKeys.all, 'downloads', id, p] as const,
};

export function useContentLibrary(params: ContentParams) {
  return useQuery({
    queryKey: contentKeys.list(params),
    queryFn: ({ signal }) => listContent(params, signal),
    placeholderData: keepPreviousData,
    meta: { silent: true },
  });
}

export function useContentDownloads(id: string, params: PageRequest) {
  return useQuery({
    queryKey: contentKeys.downloads(id, params),
    queryFn: ({ signal }) => listDownloads(id, params, signal),
    placeholderData: keepPreviousData,
    meta: { silent: true },
  });
}

/** Logging a download refreshes the counts. */
export function useTrackDownload() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (assetId: string) => trackDownload(assetId),
    onSuccess: () => qc.invalidateQueries({ queryKey: contentKeys.all }),
  });
}
